export default {
      USERS_TYPE_LIST: [
        "Администратор", "Менеджер", "Флористы", "Пользователь" , "Курьер" 
      ],
 
  };